import React, { useState, useRef } from "react";
import { Row, Col, Image, Container, Popover, OverlayTrigger, Button, Card } from "react-bootstrap";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import BhareeLogo from "./../../assets/images/bhareeLogo.png";

import { BellIcon, BurgerMenu, LogOutIcon } from "../../assets/svg/svg-icons";
import CustomButton from "../common/CustomButton";
import AdminPlaneMenu from "./AdminPlaneMenu";
import { useEffect } from "react";
import AdminPanelBharee from "./AdminPanelBharee";
import AdminPanelSeller from "./AdminPanelSeller";
import { Link } from "react-router-dom";
import { appConstants, stringConstants } from "../../helpers/app-constants";
import setAuthToken from "../../utils/setAuthToken";
import {
  getApi,
  markNotificationsAsRead,
  markSingleNotificationsAsRead,
} from "../../actions/structure.action";
import CustomOffCanvas from "../common/CustomOffCanvas";
import isEmpty from "../../utils/is-Empty";
import AdminPanelLogistic from "./AdminPanelLogistic";

const AdminPanel = () => {
  const dispatch = useDispatch();
  const [notifications, setNotifications] = useState([]);
  const [showPopover, setShowPopover] = useState(false);
  const intervalRef = useRef(null);

  const [showPanelMenu, setShowPanelMenu] = useState(false);
  const handlePanelMenuShow = () => setShowPanelMenu(true);
  const handlePanelMenuClose = () => setShowPanelMenu(false);
  const scrollRef = useRef([]);

  const [headerTitle, setHeaderTitle] = useState("");
  const [headerSubTitle, setHeaderSubTitle] = useState("");
  const [headerRoleName, setHeaderRoleName] = useState("");

  const [notificationOrderId, setNotificationOrderId] = useState(null);
  const [notificationEnquiryId, setNotificationEnquiryId] = useState(null);

  const { auth, panleCurrentView, unreadNotifications } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    getApi("getBhreeAdminBasicTables", dispatch);
  }, [dispatch]);

  const adminPlane = () => {
    if (auth.user?.role?.role_name === stringConstants.ROLL_BHAREE) {
      return (
        <AdminPanelBharee
          currentView={panleCurrentView.currentView}
          scrollRef={scrollRef}
          currentViewId={panleCurrentView.currentViewId}
          currentViewObj={panleCurrentView.currentViewObj}
        />
      );
    } else if (auth.user?.role?.role_name === stringConstants.ROLL_SELLER) {
      return (
        <AdminPanelSeller
          currentView={panleCurrentView.currentView}
          notificationOrderId={notificationOrderId}
          notificationEnquiryId={notificationEnquiryId}
          currentViewId={panleCurrentView.currentViewId}
          currentViewObj={panleCurrentView.currentViewObj}
        />
      );
    } else if (auth.user?.role?.role_name === stringConstants.ROLL_LOGISTIC_PARTNER) {
      return (
        <AdminPanelLogistic
          currentView={panleCurrentView.currentView}
          notificationOrderId={notificationOrderId}
          notificationEnquiryId={notificationEnquiryId}
          currentViewId={panleCurrentView.currentViewId}
          currentViewObj={panleCurrentView.currentViewObj}
        />
      );
    }
  };

  const handleNotificationCardClick = (notificationId) => {
    const notificationData = notifications.find((el) => el.id === notificationId);

    // If notification is related to order status
    if (notificationData?.notification_type === "NEW_ORDER") {
      if (!isEmpty(notificationData?.data_object)) {
        const orderDataObj = JSON.parse(notificationData?.data_object);
        if (!isEmpty(orderDataObj) && orderDataObj.length > 0) {
          markSingleNotificationsAsRead(dispatch, notificationId);
          handleToggle(false);
          setTimeout(() => {
            setNotificationOrderId(orderDataObj[0].id);
          }, 500);
        }
      }
    }
    // If notification is related to order status for LP
    else if (notificationData?.notification_type === "ORDER_STATUS") {
      if (!isEmpty(notificationData?.data_object)) {
        const orderDataObj = JSON.parse(notificationData?.data_object);
        if (!isEmpty(orderDataObj)) {
          markSingleNotificationsAsRead(dispatch, notificationId).then((res) => {
            console.log("markSingleNotificationsAsRead: ", res);
          });
          handleToggle(false);
          setTimeout(() => {
            setNotificationOrderId(orderDataObj.id);
          }, 500);
        }
      }
    }
    // If notification is related to enquiry status
    else if (notificationData?.notification_type === "NEW_ENQUIRY") {
      const enquiryDataObj = JSON.parse(notificationData?.data_object);
      if (!isEmpty(enquiryDataObj)) {
        markSingleNotificationsAsRead(dispatch, notificationId);
        handleToggle(false);
        setTimeout(() => {
          setNotificationEnquiryId(enquiryDataObj.enquiry_id);
        }, 500);
      }
    }
    // If notification is related to live offer end
    else if (notificationData?.notification_type === "LIVE_OFFER_END") {
      OnMenuClicked({
        type: stringConstants.SET_CURRENT_VIEW,
        payload: stringConstants.LIVE_OFFERS,
      });
      handleToggle(false);
      markSingleNotificationsAsRead(dispatch, notificationId);
    }
  };

  const clearAllNotifications = () => {
    if (notifications && notifications.length > 0) {
      markNotificationsAsRead(dispatch).then((res) => {
        handleToggle(false);
        getApi("getUnreadNotifications", dispatch); // fetch immediately
      });
    }
  };

  const popover = (
    <Popover className="notifcations-popper " id="popover-basic">
      <Popover.Header as="div" className="d-flex justify-content-between align-items-center">
        <h5 className="m-0">Notifications</h5>

        {notifications.length > 0 && (
          <Button
            variant="link"
            className="p-0 m-0 text-decoration-none small text-white"
            onClick={clearAllNotifications}
          >
            Clear All
          </Button>
        )}
      </Popover.Header>
      <Popover.Body>
        <Container>
          {notifications.length > 0 ? (
            notifications.map((notif) => (
              <Card
                key={notif.id}
                className="mb-2 shadow-sm border-0 notification-card w-100"
                onClick={() => {
                  handleNotificationCardClick(notif.id);
                }}
              >
                <div className="p-2 text-start">
                  <Card.Title className="fs-6 mb-1 fw-semibold text-start w-100">
                    {notif.title}
                  </Card.Title>
                  <Card.Text className="text-muted small mb-0 text-start w-100">
                    {notif.description}
                  </Card.Text>
                </div>
              </Card>
            ))
          ) : (
            <p className="text-center text-muted">There are no new notifications</p>
          )}
        </Container>
      </Popover.Body>
    </Popover>
  );

  // 🔹 Function to start the 5-minute interval
  const startInterval = () => {
    if (intervalRef.current) return; // avoid multiple intervals
    getApi("getUnreadNotifications", dispatch); // fetch immediately
    intervalRef.current = setInterval(() => {
      getApi("getUnreadNotifications", dispatch);
    }, 5 * 60 * 1000);
  };

  // 🔹 Function to clear the interval
  const clearIntervalIfExists = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  // 🔹 Manage interval based on login status
  useEffect(() => {
    if (auth?.loggedIn) {
      startInterval();
    } else {
      clearIntervalIfExists();
    }

    return () => clearIntervalIfExists(); // cleanup on unmount
  }, [auth]);

  useEffect(() => {
    if (unreadNotifications?.data?.length > 0) {
      setNotifications(unreadNotifications?.data);
    } else {
      setNotifications([]);
    }
  }, [unreadNotifications]);

  const handleBellClick = () => {
    if (notifications.length > 0) {
    }
  };

  // 🔹 Handle popover show/hide
  const handleToggle = (nextShow) => {
    console.log("handleToggle: nextShow: ", nextShow);
    setShowPopover(nextShow);
    if (nextShow) {
      // Popover opened → pause API polling
      clearIntervalIfExists();
    } else {
      // Popover closed → resume API polling
      if (auth?.loggedIn) startInterval();
    }
  };

  useEffect(() => {
    let mTitle = "";
    if (!isEmpty(auth?.user?.business_name)) {
      mTitle = auth?.user?.business_name;
    }

    if (
      !isEmpty(auth?.user?.role?.role_name) &&
      auth?.user?.role?.role_name === stringConstants.ROLL_BHAREE
    ) {
      if (auth?.user?.roles_type?.role_type_name === stringConstants.ROLL_TYPE_SUPER_ADMIN) {
        mTitle = "Super Admin";
      } else {
        mTitle = auth?.user?.contact_person_name;
      }
    }
    setHeaderTitle(mTitle);

    let subTitle = "";
    if (!isEmpty(auth?.user?.mobile_number)) {
      subTitle = auth?.user?.mobile_number;
    }
    if (!isEmpty(auth?.user?.app_features)) {
      subTitle += ` (${auth?.user?.app_features?.toUpperCase()})`;
    }
    setHeaderSubTitle(subTitle);

    if (!isEmpty(auth?.user?.roles_type?.role_type_name)) {
      setHeaderRoleName(auth?.user?.roles_type?.role_type_name);
    }
  }, [auth]);

  const OnMenuClicked = (setState) => {
    dispatch(setState);
    handlePanelMenuClose();
  };

  const menuColumn = (
    <>
      <div className="logo-div">
        <Link to="/">
          <Image src={BhareeLogo} alt="bhareeLogo" />
        </Link>
      </div>
      <AdminPlaneMenu
        scrollRef={scrollRef}
        handlePanelMenuClose={handlePanelMenuClose}
        dispatch={dispatch}
        auth={auth}
        OnMenuClicked={OnMenuClicked}
      />
      <CustomButton
        buttonClasses="logout-btn w-100 py-0"
        onClick={() => {
          localStorage.removeItem("jwtToken");
          localStorage.removeItem("invoiceFromDate");
          localStorage.removeItem("invoiceToDate");

          setAuthToken(false);
          dispatch({
            type: appConstants.LOGIN_SUCCESS,
            user: {},
          });
          window.location.href = "/";
        }}
      >
        <LogOutIcon />
        <span>{"log out"}</span>
      </CustomButton>
    </>
  );

  return (
    <>
      <style>
        {`
          .admin-panel-row {
            height: 100vh;
            overflow: hidden;
          }
          .admin-panel-menu-col.desktop {
            position: sticky;
            top: 0;
            height: 100vh;
            overflow-y: auto;
            z-index: 1040;
            border-right: 1px solid #eee;
          }
          .admin-panel-content-col {
            display: flex;
            flex-direction: column;
            height: 100vh;
            padding: 0;
            overflow: hidden;
          }
          .header-row {
            position: sticky;
            top: 0;
            z-index: 1030;
            background: transparent;
            border-bottom: 1px solid #eee;
          }
          .content-view {
            flex: 1 1 auto;
            overflow-y: auto;
            min-height: 0;
            background: #fafbfc;
          }
        `}
      </style>
      <section className="admin-panel-section">
        <Row className="admin-panel-row m-0">
          <Col className="admin-panel-menu-col desktop" md={3} lg={2}>
            {menuColumn}
          </Col>

          <Col className="admin-panel-content-col" xs={12} md={9} lg={10}>
            <Row className="m-0 header-row w-100">
              <div className="logo-div ms-2 mt-2 ">
                <div className="mobile burger-menu-wrap">
                  <CustomOffCanvas
                    buttonContant={<BurgerMenu />}
                    placement={"start"}
                    className="panel-ofcanvas"
                    backdropClassName="panel-backdrop"
                    bodyBsPrefix="panel-ofcanvas-body"
                    isOffCanvasOpen={showPanelMenu}
                    OffcanvasShow={handlePanelMenuShow}
                    OffcanvasClose={handlePanelMenuClose}
                  >
                    <div className="admin-panel-menu-col mobile">{menuColumn}</div>
                  </CustomOffCanvas>
                </div>
                <Link to="/" className="mobile">
                  <Image src={BhareeLogo} alt="bhareeLogo" />
                </Link>
              </div>
              <div className="header-menu-admin">
                <div className="d-flex align-items-center justify-content-between w-100 px-3">
                  <div className="page-title-wrap">
                    <h4 className="mb-0">Hello {headerTitle || ""}</h4>
                    {/* {!isEmpty(headerRoleName) && (
                      <small className="text-muted">Type: {headerRoleName}</small>
                    )} */}
                    {!isEmpty(headerSubTitle) && (
                      <small className="text-muted">{headerSubTitle}</small>
                    )}
                  </div>
                  <div className="d-flex align-items-center">
                    <OverlayTrigger
                      trigger="click"
                      placement="bottom"
                      overlay={popover}
                      rootClose
                      show={showPopover}
                      onToggle={handleToggle}
                    >
                      <Button
                        variant="light"
                        onClick={handleBellClick}
                        style={{
                          position: "relative",
                          padding: "6px",
                          border: "none",
                          background: "transparent",
                        }}
                      >
                        <BellIcon />
                        {notifications.length > 0 && (
                          <span
                            style={{
                              position: "absolute",
                              top: "0px",
                              right: "0px",
                              minWidth: "18px",
                              height: "18px",
                              backgroundColor: "red",
                              color: "white",
                              borderRadius: "50%",
                              fontSize: "12px",
                              fontWeight: "bold",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "2px",
                              lineHeight: "1",
                            }}
                          >
                            {notifications.length}
                          </span>
                        )}
                      </Button>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </Row>
            <Row className="m-0 content-view w-100">{adminPlane()}</Row>
            <div
              className="text-start copyright pt-1 pb-1 px-3"
              style={{ backgroundColor: "#000000", color: "#ffffff", fontSize: "12px" }}
            >
              <p>
                <small>
                  {"© All Copyrights By Bharee - "}
                  {new Date().getFullYear()}
                </small>
              </p>
            </div>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default AdminPanel;
